const version = '1.28.1';
export default version;
